export const noLiveGamesMessage = 'There are no live games available right now.';
export const marketBoardDict = {
    onLoadErrorTitle: 'Something went wrong',
    onLoadErrorText: 'Try refreshing the page.'
};
